import { render, staticRenderFns } from "./ed-delete-staff.component.vue?vue&type=template&id=38238638&scoped=true&"
import script from "./ed-delete-staff.component.ts?vue&type=script&lang=ts&"
export * from "./ed-delete-staff.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-delete-staff.component.scss?vue&type=style&index=0&id=38238638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38238638",
  null
  
)

export default component.exports